import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { useActions, useStore } from 'statux'

import authProvider from '../../utils/auth-provider'
import { graphqlClient, gql } from '../../utils/gql'
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator'

export default function FounderTracRegistration (props = {
    profile: null
}) {
    const setModal = useActions('modal')

    const [foundertracAccessToken, setFoundertracAccessToken]
        = useStore('foundertracAccessToken')

    const role = authProvider.getDefaultRole()

    if (!props.profile
            || !props.profile.email)
        return setModal(false)

    const [state, setState] = useState({
        consentedAt: props.profile.foundertrac_consented_at,
        subscriptionInit: Boolean(props.profile.foundertrac_consented_at) || null,
        accessToken: null
    })

    const subscriptionInterval = useRef()

    const isConsented = Boolean(state.consentedAt)

    useEffect(async () => {
        if (!state.consentedAt)
            return

        if (state.consentedAt
                && state.subscriptionInit === null) {
            const updateProfile = await graphqlClient
                .requestSafe(gql`
                    mutation {
                        update_profiles_by_pk (
                            pk_columns: {
                                email: "${props.profile.email}"
                            },
                            _set: {
                                foundertrac_consented_at: "${state.consentedAt}"
                            }
                        ) {
                            foundertrac_consented_at
                        }
                    }
                `, {}, {
                    headers: {
                        'x-hasura-role': 'me'
                    }
                })

            setState({
                consentedAt: state.consentedAt,
                subscriptionInit: Boolean((updateProfile || {}).ok),
                accessToken: null
            })
        }

        if (!state.subscriptionInit)
            return

        if (!subscriptionInterval.current
                && !state.accessToken
                && props.profile.email)
            subscriptionInterval.current = setInterval(async () => {
                const profile = (await graphqlClient
                    .request(gql`
                        query {
                            profiles_by_pk (
                                email: "${props.profile.email}"
                            ) {
                                foundertrac_account {
                                    id
                                    access_token
                                }
                            }
                        }
                    `, {}, {
                        headers: {
                            'x-hasura-role': 'me'
                        }
                    })
                    .catch(err => {
                        console.warn(err)
                        return { foundertrac_account: null }
                    })).profiles_by_pk || {}

                if ((profile.foundertrac_account || {}).access_token
                        && profile.foundertrac_account.access_token
                            !== state.accessToken)
                    setState({
                        consentedAt: state.consentedAt,
                        subscriptionInit: state.subscriptionInit,
                        accessToken: profile.foundertrac_account.access_token
                    })

                console.log('Subscription Interval', profile)
            }, 1000)

        if ((state.accessToken
                    && subscriptionInterval.current)
                || !props.profile.email)
            clearInterval(subscriptionInterval.current)

        if (state.accessToken
                && state.accessToken !== foundertracAccessToken)
            setFoundertracAccessToken(state.accessToken)
    }, [state])

    const renderConsent = () => (
        <div className="foundertrac-registration-consent">
            <h2
                id="modal-heading"
                className="margin-1-b"
            >
                {role === 'member'
                    ? 'Start your Founder Focus Assessment.'
                    : 'New partner. New features.'}
            </h2>

            <hr
                className="margin-3-t margin-3-b"
                style={{
                    color: 'var(--geyser)'
                }}
            />
            <div
                className="rich-text text-align-left body-3"
                style={{
                    color: 'var(--navy)',
                    paddingBottom: 25
                }}
            >
                {role === 'member'
                    && (
                        <>
                            <p>
                                To start your <strong>Founder Focus Assessment</strong> with
                                Catapult + FounderTrac, please opt-in to link your accounts and data.
                            </p>
                            <p>
                                This provides you access to access to:
                            </p>
                            <ul>
                                <li>
                                    <strong>Founder Focus Assessment: </strong>
                                    Take our algorithmic intake survey to identify areas
                                    your venture needs focus and support
                                </li>
                                <li>
                                    <strong>Founder Focus Map: </strong>
                                    Engage your needs and chart your progress across four
                                    lanes of acceleration – Leadership, Product, Market,
                                    and Finance
                                </li>
                                <li>
                                    <strong>Session notes: </strong>
                                    Document takeaways from advising sessions and
                                    collaborate with your advisors
                                </li>
                                <li>
                                    <strong>Advisor Matching: </strong>
                                    Get paired with the right mentor for your specific needs
                                </li>
                                <li>
                                    <strong>Waypoint completion: </strong>
                                    Submit individual milestones for review and approval,
                                    and gain confidence in your progress
                                </li>
                            </ul>
                        </>)}
                {role === 'advisor'
                    && (
                        <>
                            <p>
                                We’re excited to announce our partnership with FounderTrac
                                to bring needs assessment, milestone mapping, and advisor
                                matching to Catapult members. FounderTrac has helped over
                                400 ventures achieve their goals, connecting founders to
                                mentorship and resources.
                            </p>
                            <p>
                                Through this partnership, the Catapult members you'll
                                advise will take our Venture Assessment Survey, which
                                in turn supports the generation of a personalized
                                Founder Focus Map. This map provides a visual analysis
                                of their needs and progress across four lanes – Leadership,
                                Product, Market, and Finance – and is the centerpiece
                                for mentorship on the Catapult platform.
                            </p>
                            <p>
                                Once you're matched with a venture, you'll have access to
                                their Founder Focus Map, so you can work with them to help
                                focus their attention and support their progress against
                                specific waypoints proven to accelerate companies and drive results.
                            </p>
                            <p>To get started with Catapult + FounderTrac, please opt-in.</p>
                        </>)}
            </div>

            <div
                className="modal-footer modal-footer-sticky display-flex flex-direction-column pad-1-t pad-1-b pad-5-l pad-5-r"
                style={{
                    borderTop: '1px solid var(--geyser)',
                    background: 'var(--haze)',
                    margin: '0 -50px -50px'
                }}
            >
                <button
                    className="btn btn-secondary btn-lg"
                    onClick={() => setState({
                        consentedAt: (new Date()).toISOString(),
                        subscriptionInit: state.subscriptionInit,
                        accessToken: null
                    })}
                >
                    {role === 'member'
                        ? 'Agree and start my Founder Focus Assessment'
                        : 'Get started'}
                </button>
                <p
                    className="body-5"
                    style={{
                        marginTop: 15
                    }}
                >
                    By agreeing, you allow Catapult
                    to share your data with FounderTrac. <Link to="/advanced-membership-terms">See terms for details.</Link>
                </p>
            </div>
        </div>
    )

    const renderLoader = () => (
        <div role="status">
            <p
                className="text-align-center margin-3-b"
            >
                Creating FounderTrac Account...
            </p>
            <LoadingIndicator aria-live={false} />
        </div>
    )

    const renderSuccess = () => (
        <div
            className="foundertrac-registration-sucess row flex-justify-content-center"
            style={{
                color: 'var(--navy)',
                fontSize: '1rem'
            }}
        >
            <div className="col-12 col-10-lg-up">
                <h2
                    id="modal-heading"
                    className="margin-1-b"
                >
                    {role === 'member'
                        ? 'Start your Founder Focus Assessment.'
                        : 'New partner. New features.'}
                </h2>

                <hr
                    className="margin-3-t margin-3-b"
                    style={{
                        color: 'var(--geyser)'
                    }}
                />
                <div
                    className="rich-text body-3"
                    style={{
                        color: 'var(--navy)'
                    }}
                >
                    {role === 'member'
                        && (
                            <p>
                                Take the first step toward building a visual map highlighting
                                your venture’s unique areas of focus by starting the
                                Founder Focus Assessment.
                            </p>)}
                    {role === 'adivsor'
                        && (
                            <p>
                                Take the first step toward toward matching with
                                Catapult ventures by managing your FounderTrac account.
                            </p>)}
                </div>
                <div
                    className="modal-footer display-flex flex-direction-column pad-3-t"
                >
                    <a
                        href={`${window.FOUNDERTRAC_URL}/authorize/${
                            window.FOUNDERTRAC_CLIENT_ID}?a=${
                            state.accessToken}`}
                        className="btn-secondary btn-lg"
                        rel="noopener noreferrer"
                        target="_blank"
                        title="Opens in a new tab"
                        onClick={() => setModal(false)}
                    >
                        {role === 'member'
                            ? 'Start assessment'
                            : 'Manage your FounderTrac account'}
                        <svg
                            className="icon-launch"
                            width="16"
                            height="16"
                            style={{ marginLeft: 5 }}
                        >
                            <use xlinkHref="#icon-launch" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    )

    return state.accessToken
        ? renderSuccess()
        : (!isConsented
            ? renderConsent()
            : renderLoader())
}
